import TemplateView from "../TemplateView";
import SpinnerController from "../SpinnerController";
import Spinner from "../spin.min";

export default class LoadingSpinner extends TemplateView {
    constructor({
        delay = 0,
        config = {}
    } = {}) {
        super(null)

        this.params = {
            delay,
            config
        }

        this.state = {
            show: false
        }

        this.onStatePropertyChanged('show', show => this._show(show))
    }

    templateHtml() {
        return '<div class="loadingSpinner"/>'
    }

    afterRender() {
        this.$el.hide();
        this.spinnerController = new SpinnerController(true);
        this.spinnerController.setSpinner(new Spinner({...SpinnerController.getDefaultSettings(), ...this.params.config}));
    }

    _show(show) {
        clearTimeout(this._showTimeout);

        if (show) {
            if (this.params.delay) {
                this._showTimeout = setTimeout(() => this.$el.show(), this.params.delay);
            } else {
                this.$el.show()
            }
            this.spinnerController.spinInElement(this.getEl())
        } else {
            this.spinnerController.stop()
            this.$el.hide();
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/components/LoadingSpinner.js